
import {defineComponent,ref,reactive} from 'vue'
export default defineComponent({
    props: {
        userMenus: {
            type: Object,
            default: () =>({})
        }
    },
    methods: {
    handleMenuItemClick(submenu:any) {
        // if (submenu.name === '报表查询') {
        //     // 在新标签页打开百度
        //     window.open('http://10.10.40.162/chatbot/KvPqEEX8CpwSKaRE', '_blank');
        // } else {
        
            // 默认的导航逻辑
            this.$router.push(submenu.router);
        //}
    }
}
    
})
